import times from 'lodash/times'

import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import { Switch } from '@/components/ui/switch'

export const TikTokListDetailsSkeleton = () => {
  return (
    <div className="space-y-8 px-4 py-8 pb-14 xl:container lg:px-16 xl:mx-auto">
      <Skeleton className="h-14 max-w-[270px]" />
      <div className="flex justify-between gap-6 max-md:flex-col">
        <Skeleton className="h-10 w-full max-w-[400px]" />
        <div className="flex gap-4">
          <Skeleton className="h-10 w-[150px]" />
          <Skeleton className="h-10 w-[150px]" />
        </div>
      </div>
      <div className="space-y-6">
        <Separator className="mb-6" />
        <div className="mb-4 flex justify-between">
          <div className="text-xl font-semibold">Videos</div>
          <div className="flex gap-4">
            Show
            <Switch
              checked
              disabled
              className="bg-secondary-300 [[aria-checked=false]&>*]:bg-[#fff]"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-4">
          {times(4).map((i) => (
            <Skeleton
              key={i}
              className="h-full min-h-[493px] w-full"
            />
          ))}
        </div>
        <Separator className="mb-6" />
        <div className="mb-4 flex justify-between">
          <div className="text-xl font-semibold">Sounds</div>
          <div className="flex gap-4">
            Show
            <Switch
              checked
              disabled
              className="bg-secondary-300 [[aria-checked=false]&>*]:bg-[#fff]"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 lg:grid-cols-4">
          {times(4).map((i) => (
            <Skeleton
              key={i}
              className="h-full min-h-[417px] w-full"
            />
          ))}
        </div>
      </div>
    </div>
  )
}
